var map = {
	"./1.jpg": "./src/Content/Recipe Images/1.jpg",
	"./11.jpg": "./src/Content/Recipe Images/11.jpg",
	"./13.jpg": "./src/Content/Recipe Images/13.jpg",
	"./14.jpg": "./src/Content/Recipe Images/14.jpg",
	"./15.jpg": "./src/Content/Recipe Images/15.jpg",
	"./16.jpg": "./src/Content/Recipe Images/16.jpg",
	"./17.jpg": "./src/Content/Recipe Images/17.jpg",
	"./20.jpg": "./src/Content/Recipe Images/20.jpg",
	"./21.jpg": "./src/Content/Recipe Images/21.jpg",
	"./28.jpg": "./src/Content/Recipe Images/28.jpg",
	"./33.jpg": "./src/Content/Recipe Images/33.jpg",
	"./34.jpg": "./src/Content/Recipe Images/34.jpg",
	"./35.jpg": "./src/Content/Recipe Images/35.jpg",
	"./36.jpg": "./src/Content/Recipe Images/36.jpg",
	"./37.jpg": "./src/Content/Recipe Images/37.jpg",
	"./4.jpg": "./src/Content/Recipe Images/4.jpg",
	"./5.jpg": "./src/Content/Recipe Images/5.jpg",
	"./7.jpg": "./src/Content/Recipe Images/7.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Content/Recipe Images sync recursive ^\\.\\/.*$";